// src/enums.ts

export enum ButtonSide {
    Left = "L",
    Right = "R",
}

export enum ButtonColor {
    //
    Pink = "#F23CFF",
    PinkHover = "#DA16E3",
    //
    Purple = "#8000FF",
    PurpleHover = "#6603C9",
    //
    LightningDefault = "#F5F5F5",
    LightningHover = "#E5E5E5",
    LightningActive = "#F23CFF",
    //
    ReportDefault = "#BEBEBE",
    ReportHover = "#6B7280",
    //dummy colors
    Black = "black",
    Grey = "grey",
    White = "white"
}
